module.exports = __webpack_public_path__ + "img/card.60ddc014.svg";